/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { FilterLogic } from './filterLogic.schema';
import { IFilterBase } from './iFilterBase.schema';

export type CompositeFilter = {
  logic?: FilterLogic;
  filters?: IFilterBase[];
};

export const CompositeFilter: zod.ZodType<CompositeFilter> = zod.object({
  "logic": zod.lazy(() => FilterLogic).optional(),
  "filters": zod.array(zod.lazy(() => IFilterBase)).optional()
});

export type CompositeFilterOutput = zod.output<typeof CompositeFilter>;
